import api_php from '@/api/api_php.js'


let _shareLogo = require('@/assets/imgs/app/company_logo.png');

const share = function (b) {

  var params = {
    branch: sessionStorage['c_id'],
    url: window.entryUrl || window.location.href
  }

  api_php.getJssdkConfig(res => {
      if (res.code == 0) {
        // res.data.debug = true;
        //是否匹配api
        wx.checkJsApi({
          jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareTimeline', 'onMenuShareAppMessage','hideMenuItems','showMenuItems','hideAllNonBaseMenuItem'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
          success: function (res) {}
        });
        // 注入权限验证配置
        wx.config({ ...res.data,
          jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'checkJsApi','hideMenuItems','showMenuItems','hideAllNonBaseMenuItem']
        });

        wx.ready(function () {
          wx.showMenuItems({
            menuList:['menuItem:share:appMessage','menuItem:share:timeline','menuItem:copyUrl']
          })
          if(b.isShare) {
            wx.onMenuShareTimeline({
              // wx.updateTimelineShareData({
              title: b.title,
              link: window.location.href,
              imgUrl: 'https://jfinfo.oss-cn-beijing.aliyuncs.com/juzhen/logo.png',
              success: function () {
                // 用户确认分享后执行的回调函数
                //alert('分享到朋友圈成功');
              },
              cancel: function () {
                // 用户取消分享后执行的回调函数
                //  alert('你没有分享到朋友圈');
              }
            });
            wx.onMenuShareAppMessage({
              // wx.updateAppMessageShareData({
              title: b.title,
              desc: b.desc,
              link: window.location.href,
              imgUrl: 'https://jfinfo.oss-cn-beijing.aliyuncs.com/juzhen/logo.png',
              trigger: function (res) {
                // 不要尝试在trigger中使用ajax异步请求修改本次分享的内容，因为客户端分享操作是一个同步操作，这时候使用ajax的回包会还没有返回
              },
              success: function (res) {
                // alert('分享给朋友成功');
              },
              cancel: function (res) {
                // alert('你没有分享给朋友');
              },
              fail: function (res) {
                // alert(JSON.stringify(res));
              }
            });
          }else{
            // wx.hideMenuItems({
            //   menuList:['menuItem:share:appMessage','menuItem:share:timeline','menuItem:copyUrl']
            // });
            wx.hideAllNonBaseMenuItem();
          }
        })

      } else {
        console.log('分享配置项数据获取出错!')
      }
    },
    params
  );
}


export default share



// WEBPACK FOOTER //
// ./src/assets/js/share.js